<template>
  <button type="button" class="dashboard-action" @click="$emit('click')">
    <i v-if="icon" :class="'el-icon-' + icon" class="dashboard-action__icon"></i>
    <span class="dashboard-action__text">
      <slot></slot>
    </span>
  </button>
</template>

<script>
  export default {
    name: "dashboard-action",
    props: {
      icon: {
        type: String,
        required: false
      }
    }
  }
</script>

<style scoped>
  .dashboard-action {
    display: flex;
    align-items: center;
    gap: 14px;
    height: 76px;
    padding: 0 20px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background-color: white;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
  }

  .dashboard-action:hover,
  .dashboard-action:focus {
    border-color: var(--lav-green);
    box-shadow: 0 6px 16px rgba(16, 24, 40, 0.08);
    outline: none;
    transform: translateY(-1px);
  }

  .dashboard-action__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: var(--lav-green-soft);
    color: var(--lav-green-dark);
    font-size: 20px;
  }

  .dashboard-action__text {
    font-size: 15px;
    font-weight: 600;
    color: var(--text);
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard-action.vue